import styled from 'styled-components';

export const Container = styled.div``;

export const CropperBox = styled.div`
  width: 100%;
  max-width: auto;
  min-width: 300px;
  height: auto;
  max-height: auto;
  min-height: 250px;
  margin: 0 auto;

  .cropper-container {
    position: relative;
    overflow: hidden;
    border-radius: 18px;

    &::before {
      content: '';
      position: absolute;
      top: -10%;
      left: -10%;
      width: 120%;
      height: 120%;
      background-image: var(--cropper-bg-image);
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      filter: blur(15px);
      z-index: 0;
      pointer-events: none;
    }
  }

  .cropper-bg {
    background: transparent !important;
    background-image: none !important;
  }

  .cropper-wrap-box,
  .cropper-drag-box {
    background-color: transparent;
  }

  .cropper-modal {
    background-color: rgba(0, 0, 0, 0.45);
    opacity: 1;
  }

  .cropper-crop-box {
    border-radius: 18px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }

  .cropper-view-box {
    position: relative;
    border-radius: 18px;
    outline: 2px solid #ffcb29;
    outline-offset: 0;

    > img {
      position: relative;
      z-index: 1;
      transform-origin: center center !important;
    }
  }

  .cropper-canvas img {
    transform-origin: center center !important;
  }

  .cropper-dashed {
    border-width: 1px;
    opacity: 0.5;
  }

  .cropper-center {
    display: none;
  }
`;
